import * as React from 'react';

import {formEncodedApi} from 'nutshell-core/api';

import {Button} from 'shells/button/button';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {SupportModal} from 'shells/support-modal/support-modal';
import {TextField} from 'shells/textfield/textfield';

import {useGetSessionUser} from '../../core/use-get-session-user';

import styles from './get-api-support.module.css';

export function GetAPISupport() {
    const [isRequesting, setIsRequesting] = React.useState<boolean>(false);
    const [name, setName] = React.useState<string>('');
    const [email, setEmail] = React.useState<string>('');
    const [description, setDescription] = React.useState<string>('');

    const {user} = useGetSessionUser();
    React.useEffect(() => {
        if (user) {
            setName(user.name);
            // @ts-expect-error
            setEmail(user.emailAddresses[0].address);
        }
    }, [user]);

    const openModal = () => setIsRequesting(true);
    const closeModal = () => setIsRequesting(false);

    const formValues = {name, email, description} as const;
    const isSubmitDisabled = !name || !email || !description;

    const submitForm = () => {
        formEncodedApi.post('/request-support/api-support.json', {
            ...formValues,
        });
    };

    return (
        <>
            <div className='mb-16'>
                <Button onClick={openModal} variant='primary' size='big' isFullWidth={true}>
                    Get API support
                </Button>
            </div>
            {isRequesting ? (
                <SupportModal
                    onClose={closeModal}
                    headerText='Request API support'
                    headerSubtext='Need help using Nutshell’s API? Our team is here to assist you. Simply fill out the form below to let us know what you’re trying to accomplish and we’ll be in touch as soon as possible.'
                    form={
                        <StackLegacy spacing={8}>
                            <div>
                                <label htmlFor='name'>
                                    Name&nbsp;<span className={styles.red}>*</span>
                                </label>
                                <TextField
                                    id='name'
                                    placeholder='John Appleseed'
                                    type='text'
                                    value={name}
                                    onChange={setName}
                                />
                            </div>
                            <div>
                                <label htmlFor='name'>
                                    Email&nbsp;<span className={styles.red}>*</span>
                                </label>
                                <TextField
                                    id='email'
                                    placeholder='john.appleseed@nutshell.com'
                                    type='email'
                                    value={email}
                                    onChange={setEmail}
                                />
                            </div>
                            <div>
                                <label htmlFor='name'>
                                    Description&nbsp;<span className={styles.red}>*</span>
                                </label>
                                <TextField
                                    id='description'
                                    placeholder='Explain your API issue – the more detail you’re able to provide the more effectively our team is able to help!'
                                    multiline={true}
                                    value={description}
                                    onChange={setDescription}
                                />
                            </div>
                        </StackLegacy>
                    }
                    onSubmit={submitForm}
                    isSubmitDisabled={isSubmitDisabled}
                />
            ) : undefined}
        </>
    );
}
